import React, { useEffect, useRef, useState } from "react";
import "./style.scss";
import { useStores } from "../../stores";
import NoImage from "../../assets/images/noImage.jpg";
import Header from "../../components/Header";
import notify from "../../components/Notify/notify";
import { useLocation, useNavigate } from "react-router-dom";
import InvoiceDownload from "../../assets/images/download.png";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { bookingStore } = useStores();
  const { state } = useLocation();
  const [couponDiscount, setInventoryPrice] = useState([]);
  const [selectedSpaceItem, setSelectedSpaceItem] = useState([]);
  const [selectedInvItem, setSelectInvItem] = useState([]);
  const selectSpaceItem = sessionStorage.getItem("selectSpaceItem");
  const selectInverntoryItem = sessionStorage.getItem("selectInverntoryItem");
  const selectedDate = sessionStorage.getItem("selectedDate");
  const selectSlotItem = sessionStorage.getItem("selectSlotItem");
  let parseDate = JSON.parse(selectedDate);
  const [selectDate, setSelectDate] = useState(parseDate);
  const [selectSlot, setSelectSlot] = useState([]);
  const [accessKey, setAccessKey] = useState("");
  const [campaign, setCampaign] = useState({});
  const [spaceName, setSpaceName] = useState("");
  const [selectedSpaceItemId, setSelectedSpaceItemId] = useState("");
  const [coupon, setCoupon] = useState("");

  const [inventryData, setInventryData] = useState({});
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);
  const [bookingDate, setBookingDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [currentPathname, setCurrentPathname] = useState(null);
  const [currentSearch, setCurrentSearch] = useState(null);
  const [dayPassPayment, setDayPassPayment] = useState(false);

  useEffect(() => {
    let newvar = window.location.pathname;
    let tempData = newvar.split("/payment/success/")[1];
    let key = tempData.split("/")[0];
    setAccessKey(key);
    let txnId = tempData?.split("/")[1];
    // console.log(tempData);
    getPaymentStatus(key, txnId);

    // window.history.pushState(null, null, newvar);
    window.onpopstate = function () {
      window.history.go(1);
      window.location.reload();
    };
  }, []);
  

  const getPaymentStatus = async (key, txnId) => {
    setLoader(true);
    let params = `access_key=${key}&txn_id=${txnId}`;
    await bookingStore.getBookingStatus(params, (response) => {
      if (response?.data?.status === 1) {
        // console.log(response?.data?.data);
        setInventryData(response?.data?.data);
        let tempTime = response?.data?.data?.booking_data?.valid_from;
        let bookingDate = tempTime?.split(" ")[0];
        let startTime = tempTime?.split(" ")[1];
        // setBookingDate(bookingDate);
        let dayPass = response?.data?.data?.booking_data?.inventory_name;
        dayPass = dayPass.trim().toLowerCase();
        if(dayPass === "day pass"){
          setDayPassPayment(true)

          const urlParams = sessionStorage.getItem('urlParams');
          if (urlParams) {
            const currentURL = window.location.href;
            const newURL = currentURL + (currentURL.includes('?') ? '&' : '?') + urlParams;
            window.history.replaceState({}, document.title, newURL);
          }
        }

        getBookingDate(bookingDate);
        setStartTime(
          `${startTime?.split(":")[0]}:${
            startTime?.split(":")[1]?.split(":")[0]
          }`
        );
        let tempEndTime = response?.data?.data?.booking_data?.valid_upto;
        let endTime = tempEndTime?.split(" ")[1];
        setEndTime(
          `${endTime?.split(":")[0]}:${endTime?.split(":")[1]?.split(":")[0]}`
        );
        setLoader(false);
      } else {
        setLoader(false);
        console.log("error");
      }
    });
  };

  const getBookingDate = (date) => {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    let tempDate = new Date(date).toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    let day = weekday[new Date(tempDate).getDay()];
    setBookingDate(`${day}, ${tempDate}`);
  };

  return (
    <>
      <Header accessKey={accessKey} queryParams={window.location.origin + `/day-pass/${accessKey}`} dayPass={dayPassPayment} />
      {loader ? (
        <div className="loader"></div>
      ) : (
        <div className="payment-result-container">
          <section className="booking-listing-section">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="payment-detail-box">
                    <div className="row">
                      <div className="col-md-6  no-gutters">
                        <div className="payment-content">
                          <div className="banner-tag">
                            <h3 className="banner-tag-text">
                              {inventryData?.booking_data?.inventory_name}
                            </h3>
                          </div>
                          <img
                            src={
                              inventryData?.booking_data?.image[0] || NoImage
                            }
                            alt="Payment Banner"
                            className="payment-banner"
                          />
                          <h3 className="payment-content-heading">
                            {inventryData?.space_name}
                          </h3>
                          <p className="payment-content-text">
                            {inventryData?.address}
                          </p>
                          <div className="payment-date-box">
                            <p className="payment-date-text">{bookingDate}</p>
                            <p className="payment-date-text">
                              {startTime} - {endTime}
                            </p>
                            {!dayPassPayment && (
                              <p className="payment-date-text">
                                {inventryData?.booking_data?.capacity} Seater{" "}
                                {inventryData?.booking_data?.inventory_name}
                              </p>
                            )}
                              {dayPassPayment && (
                              <p className="payment-date-text">
                                {inventryData?.quantity} Quantity{" "}
                              </p>
                            )}
                          </div>
                          {!dayPassPayment && (
                            <div className="add-fb-setion">
                              <p className="modal-btn">
                                F&B Detail
                              </p>
                              {inventryData?.fnb_data?.length > 0 ? (
                                <p className="order-id">
                                  Order Id - {inventryData?.pos_id}
                                </p>
                              ) : (
                                <p className="order-id">No Add ons</p>
                              )}
                            </div>
                          )}

                          {inventryData?.fnb_data?.map((item) => {
                            return (
                              <div className="list-box">
                                <div className="list-box-inner">
                                  <p className="list-box-fitem">{item.name}</p>
                                  <p className="list-box-litem">{Number(item?.price) * item?.qty}</p>
                                </div>
                                <div className="list-box-inner">
                                  <p className="list-box-sfitem">Qty</p>
                                  <p className="list-box-slitem">{item?.qty}</p>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="billing-detail-box success">
                          <h2 className="bookind-id">
                            Booking ID - {inventryData?.booking_id}
                          </h2>
                          {dayPassPayment ? (
                            <h3 className="sucess-message">
                              Congratulations! your Day Pass is booked successfully.
                            </h3>
                          ) : (
                            <h3 className="sucess-message">
                              Congratulations! your meeting room is booked successfully.
                            </h3>
                          )}
                          <div className="client-detail-box">
                            <h3 className="client-detai-heading">
                              Customer Details
                            </h3>
                            <div className="client-detail-inner">
                              <p className="cd-text">
                                Name: {inventryData?.user_data?.name}
                              </p>
                              <p className="cd-text">
                                Mobile Number: {inventryData?.user_data?.mobile}
                              </p>
                              <p className="cd-text">
                                Email Id: {inventryData?.user_data?.email}
                              </p>
                            </div>
                          </div>
                          <p className="billing-detail-heading">
                            Billing Details
                          </p>
                          <div className="total-price-box mt-2">
                            <div className="total-price-inner">
                              <p className="total-text">Sub Total</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.sub_total}
                              </p>
                            </div>
                            <div className="total-price-inner">
                              <p className="total-text">SGST(9%)</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.sgst}
                              </p>
                            </div>
                            <div className="total-price-inner">
                              <p className="total-text">CGST(9%)</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.cgst}
                              </p>
                            </div>
                            <div className="total-price-inner">
                              <p className="total-text">IGST(0%)</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.igst}
                              </p>
                            </div>
                            <div className="total-price-inner">
                              <p className="total-text">Discount</p>
                              <p className="text-price">
                                Rs {inventryData?.booking_data?.discount}
                              </p>
                            </div>
                            <div className="total-price-inner-big">
                              <p className="total-text-big">Sub Total</p>
                              <p className="text-price-big">
                                Rs {inventryData?.booking_data?.total}/-
                              </p>
                            </div>
                            <div className="total-price-inner">
                            {!dayPassPayment && (
                              <p className="total-text">
                                {inventryData?.addon_amount !== 0
                                  ? "F&B"
                                  : "No F&B Added"}
                              </p>
                            )}
                              <p className="text-price">
                                {inventryData?.addon_amount !== 0 && inventryData?.addon_amount}
                              </p>
                            </div>
                            <div className="total-price-inner-gbig">
                              <p className="total-text-gbig">Grand Total</p>
                              <p className="text-price-gbig">
                                Rs {inventryData?.amount} /-
                              </p>
                            </div>
                            {inventryData?.invoice_link !== "" && inventryData?.invoice_link !== undefined && 
                            <div className="total-price-inner-gbig"> 
                              <a href={inventryData?.invoice_link} download className="invoice-text-big">
                                <img
                                  src={InvoiceDownload}
                                  alt="Payment Banner"
                                  className="Invoice_Download"
                                />
                                Invoice
                              </a>
                            </div>
                            }
                            {inventryData?.pos_invoice_link !== "" && inventryData?.pos_invoice_link !== undefined && 
                            <div className="total-price-inner-gbig">
                              <a href={inventryData?.pos_invoice_link} download className="invoice-text-big">
                                <img
                                  src={InvoiceDownload}
                                  alt="Payment Banner"
                                  className="Invoice_Download"
                                />
                                F&B Invoice
                              </a>
                            </div>
                            }
                            {/* <div className="payment-btn-box text-center">
                              <button
                                type="button"
                                className={"pay-btn"}
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate(
                                    `/${process.env.REACT_APP_BASE_FOLDER}/${accessKey}`
                                  );
                                }}
                              >
                                Go To Home
                              </button>
                            </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default PaymentSuccess;
